// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit'

import { API_PATH_RESALE, API_PATH_RESALE_ORDER } from '@/api/apiRoutes'
import { post, get } from '@/util/auth'

export const NAME = 'resale'

export const fetchStatus = () => async dispatch => {
  const { listings, orders } = await get(API_PATH_RESALE)
  dispatch(setListings(listings))
  dispatch(setOrders(orders))
}

export const postOrder = (id, price) => async dispatch => {
  dispatch(setPostErrorId())
  try {
    await post(API_PATH_RESALE_ORDER, { listingId: id, price })
  } catch {
    dispatch(setPostErrorId(id))
  } finally {
    await dispatch(fetchStatus())
  }
}

const initialState = {
  listings: [],
  orders: [],
  postErrorId: undefined,
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setListings: (state, { payload: listings }) => {
      state.listings = listings
    },
    setOrders: (state, { payload: orders }) => {
      state.orders = orders
    },
    setPostErrorId: (state, { payload: postErrorId }) => {
      state.postErrorId = postErrorId
    },
    reset: () => ({ ...initialState }),
  },
})

export const { setListings, setOrders, setPostErrorId, reset } = actions
export default reducer

const getState = state => state[NAME]

export const getHasPostError = (state, id) => getState(state).postErrorId === id

export const getListings = state => getState(state).listings || []
export const getListingFromId = (state, id) =>
  getListings(state).find(listing => listing.id === id) || {}

export const getOrders = state => getState(state).orders
export const getOrdersFromListingId = (state, listingId) =>
  getOrders(state).filter(order => order.listing_id === listingId)
